export const getPosts = function(container, button, offset) {
    const spinner = document.querySelector('.loading-spinner');
    if(spinner) {
        spinner.classList.add('show');
    }
    const totalPosts = parseInt(container.getAttribute('data-total'));

    let data = new FormData();
    data.append('action', 'get_posts');
    data.append('offset', offset);
    $.ajax({
        url: norlights_scripts.ajax_url,
        type: 'POST',
        data: data,
        cache: false,
        processData: false,
        contentType: false,
        error: function (data) {
            console.error(data);
        },
        success: function (data) {
            container.insertAdjacentHTML('beforeend', data);
            if(spinner) {
              spinner.classList.remove('show');
            }
            if (container.querySelectorAll('.tease').length >= totalPosts) {
                button.classList.remove('show');
            }
        }
    });
}

export const getMediaPosts = function(container, button, offset, selectedType, selectedCategory) {
    const spinner = document.querySelector('.loading-spinner');
    if(spinner) {
        spinner.classList.add('show');
    }
    const totalPosts = parseInt(container.getAttribute('data-total'));
    let shownPosts = Array.from(container.querySelectorAll('.media')).map(item => item.getAttribute('data-id'));
   
    let data = new FormData();
    data.append('action', 'get_media_posts');
    data.append('type', selectedType);
    data.append('category', selectedCategory);
    data.append('offset', offset);
    data.append('shown_posts', JSON.stringify(shownPosts));
    $.ajax({
        url: norlights_scripts.ajax_url,
        type: 'POST',
        data: data,
        cache: false,
        processData: false,
        contentType: false,
        error: function (data) {
            console.error(data);
        },
        success: function (data) {
            container.insertAdjacentHTML('beforeend', data);
            if(spinner) {
              spinner.classList.remove('show');
            }
            if (container.querySelectorAll('.media').length >= totalPosts) {
                button.classList.remove('show');
            }
        }
    });
}